export class MxUiManagerController {
	static $inject = ['mx.shell.SearchProviderService', 'mx.shell.ContextService'];

	searchService;
	contextService;

	constructor(searchService, contextService) {
		this.searchService = searchService;
		this.contextService = contextService;
	}

	$onInit() {
		const currentSearch = this.searchService.currentSearch();
		this.datasetViewData = (this.contextService.val('SolutionBuilderAgent.DataSetView.Data') || []).map((item) => ({
			ObjectId: item['Sys-ObjectId'],
			TypeName: item['Sys-Entity'],
		}));
		this.datasetViewId = currentSearch.dataQueryList.parameters.id;
		this.keyword = currentSearch.keyword;

		const quickFilter = (currentSearch.dataQueryList.quickFilterPreprocessor && currentSearch.dataQueryList.quickFilterPreprocessor.filters) || [];
		this.filters = currentSearch.filters && currentSearch.filters[0] ? currentSearch.filters.concat(quickFilter) : quickFilter;

		if (currentSearch.dataQueryList.sortingPreprocessor) {
			this.orderBy = currentSearch.dataQueryList.sortingPreprocessor.build();
			if (this.orderBy) {
				this.orderBy = this.orderBy.replace('orderBy=', '');
			}
		}

		if (currentSearch.dataQueryList.structurePreprocessor) {
			this.structureNodeId = currentSearch.dataQueryList.structurePreprocessor.getNodeId();
		}

		this.selectedColumns = currentSearch.dataQueryList.columns
			.filter((column) => column.visible)
			.map((column) => column.Name)
			.join(',');

		this.selectedViewType = currentSearch.dataQueryList.type;
	}
}

angular.module('mx.SolutionBuilderAgent').component('mxUiManager', {
	template: '',
	controller: MxUiManagerController,
	controllerAs: 'vm',
	bindings: {
		datasetViewId: '=?',
		datasetViewData: '=?',
		orderBy: '=?',
		keyword: '=?',
		filters: '=?',
		structureNodeId: '=?',
		selectedColumns: '=?',
		selectedViewType: '=?',
	},
});
